import { state, mutations, getters, actions } from '@js/configs/vuexResultCommon'

const resultModule = {
    state,
    mutations,
    getters,
    actions,
}

export default resultModule
